export type Environment = 'development' | 'production';

export const getEnvironment = (): Environment => {
    const hostname = window.location.hostname;

    // Desenvolvimento: Localhost ou o projeto Firebase de desenvolvimento (-d)
    if (
        hostname === 'localhost' || 
        hostname === '127.0.0.1' || 
        hostname.includes('gm-contabilidade-web-d')
    ) {
        return 'development';
    }

    // Todo o resto (incluindo gmcontabilidade.com.br) é produção
    return 'production';
};

export const isDevEnvironment = (): boolean => getEnvironment() === 'development';
export const isProdEnvironment = (): boolean => getEnvironment() === 'production';

export const isDebugMode = (): boolean => {
    return isDevEnvironment();
};
